module.exports = __webpack_public_path__ + "img/KSC88888.74deecc7.jpg";